export const footerEditorConfig = [
    ['bold', 'italic', 'underline', 'strike'],
    [{script: 'sub'}, {script: 'super'}],
    ['link'], [{font: []}],
    [{align: ''}, {align: 'center'}, {align: 'right'}, {align: 'justify'}],
    ['clean'],
];
